/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Create_Ad_TemplateInputs */

const en_event_group_options_create_ad_template = /** @type {(inputs: Event_Group_Options_Create_Ad_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create AD Template`)
};

const fr_event_group_options_create_ad_template = /** @type {(inputs: Event_Group_Options_Create_Ad_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un modèle de description audio`)
};

const de_event_group_options_create_ad_template = /** @type {(inputs: Event_Group_Options_Create_Ad_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD-Vorlage erstellen`)
};

const it_event_group_options_create_ad_template = /** @type {(inputs: Event_Group_Options_Create_Ad_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea modello di annuncio`)
};

const ru_event_group_options_create_ad_template = /** @type {(inputs: Event_Group_Options_Create_Ad_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать шаблон объявления`)
};

const es_event_group_options_create_ad_template = /** @type {(inputs: Event_Group_Options_Create_Ad_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear plantilla de AD`)
};

const zh_cn2_event_group_options_create_ad_template = /** @type {(inputs: Event_Group_Options_Create_Ad_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建 AD 模板`)
};

const ja_event_group_options_create_ad_template = /** @type {(inputs: Event_Group_Options_Create_Ad_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADテンプレートを作成する`)
};

const hi_event_group_options_create_ad_template = /** @type {(inputs: Event_Group_Options_Create_Ad_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD टेम्पलेट बनाएं`)
};

const pt_pt2_event_group_options_create_ad_template = /** @type {(inputs: Event_Group_Options_Create_Ad_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar modelo de anúncio`)
};

/**
* | output |
* | --- |
* | "Create AD Template" |
*
* @param {Event_Group_Options_Create_Ad_TemplateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_create_ad_template = /** @type {((inputs?: Event_Group_Options_Create_Ad_TemplateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Create_Ad_TemplateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_create_ad_template(inputs)
	if (locale === "de") return de_event_group_options_create_ad_template(inputs)
	if (locale === "it") return it_event_group_options_create_ad_template(inputs)
	if (locale === "ru") return ru_event_group_options_create_ad_template(inputs)
	if (locale === "es") return es_event_group_options_create_ad_template(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_create_ad_template(inputs)
	if (locale === "ja") return ja_event_group_options_create_ad_template(inputs)
	if (locale === "hi") return hi_event_group_options_create_ad_template(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_create_ad_template(inputs)
	return en_event_group_options_create_ad_template(inputs)
});